import apolloClient from '../../apolloClient';
import usersQueries from '../queries/users';
import usersMutations from '../mutations/users';

const getCustomerMembers = async (variables) =>
  apolloClient.query({
    query: usersQueries.GET_CUSTOMER_MEMBERS,
    variables,
    fetchPolicy: 'no-cache',
  });

const removeCustomerMember = async (variables) =>
  apolloClient.mutate({
    mutation: usersMutations.REMOVE_CUSTOMER_MEMBER,
    variables,
    fetchPolicy: 'no-cache',
  });

const updateUserRoleByWorkspaceId = async (variables) =>
  apolloClient.mutate({
    mutation: usersMutations.UPDATE_USER_ROLE_BY_WORKSPACE_ID,
    variables,
    fetchPolicy: 'no-cache',
  });

const getChatUsers = async (variables) =>
  apolloClient.query({
    query: usersQueries.GET_CHAT_USERS,
    variables,
    fetchPolicy: 'no-cache',
  });

const getChatUsersBySituationId = async (variables) =>
  apolloClient.query({
    query: usersQueries.GET_CHAT_USERS_BY_SITUATION_ID,
    variables,
    fetchPolicy: 'no-cache',
  });

const updateUserRoleByCustomerId = async (variables) =>
  apolloClient.mutate({
    mutation: usersMutations.UPDATE_USER_ROLE_BY_CUSTOMER_ID,
    variables,
    fetchPolicy: 'no-cache',
  });

const setCustomerMemberAll = async (variables) =>
  apolloClient.mutate({
    mutation: usersMutations.SET_CUSTOMER_MEMBER_ALL,
    variables,
    fetchPolicy: 'no-cache',
  });

const setCustomerMemberDevices = async (variables) =>
  apolloClient.mutate({
    mutation: usersMutations.SET_CUSTOMER_MEMBER_DEVICES,
    variables,
    fetchPolicy: 'no-cache',
  });

export default {
  getCustomerMembers,
  removeCustomerMember,
  updateUserRoleByWorkspaceId,
  getChatUsers,
  getChatUsersBySituationId,
  updateUserRoleByCustomerId,
  setCustomerMemberAll,
  setCustomerMemberDevices,
};
